import { useAuthStore } from '@/stores/authStore'

export function useMiniAppQueryScope(): string | null {
  return useAuthStore((state) =>
    state.user && state.tenant ? `account:${state.user.id}:tenant:${state.tenant.id}` : null
  )
}

export function miniAppQueryKey(scope: string | null, ...parts: readonly unknown[]) {
  return ['private', scope ?? 'unauthenticated', ...parts] as const
}
